import styled from 'styled-components';
import { colors } from '@styles';
import { flexMixin, textMixin } from '@styles/mixins';

export const Wrapper = styled.div`
    ${flexMixin('column', 'flex-start', 'center')};
    width: 100%;
    min-height: calc(100vh - 110px);
    background-color: ${colors.bgWhite};

    .ant-table-thead > tr > th {
        background-color: ${colors.tableHeadBg};
        line-height: 16px;
        text-align: left;
    }

    .ant-pagination {
        background-color: ${colors.tableHeadBg};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 400,
        })};
        line-height: 16px;
        text-align: left;
        margin: 0 !important;
        margin-top: 5px !important;
        padding: 16px;
        background: ${colors.cleanWhite};
        box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.1);
        border-radius: 0 0 5px 5px;
    }

    table > tbody > tr > td {
        background-color: ${colors.cleanWhite};
        border: 1px solid #efefef;
        color: ${colors.grey};
        ${textMixin({
            fontSize: '0.875rem',
            fontWeight: 400,
        })};
        line-height: 16px;
        text-align: left;
        height: 30px;
    }
`;

export const HeaderWrapper = styled.div`
    width: 100%;
    ${flexMixin('row', 'space-between', 'center')}
    padding: 20px 0;
`;
export const Title = styled.div`
    ${textMixin({
        fontSize: '2rem',
        fontWeight: 600,
    })};
    line-height: 28px;
    display: flex;
    align-items: center;
    color: ${colors.grey};
`;

export const StyledCalendarWrapper = styled.div`
    ${flexMixin('row', 'space-between', 'center')};
    color: ${colors.white};

    & svg {
        width: 20px;
        height: 20px;
    }
    .ant-picker {
        background-color: ${colors.primaryBg};
        ${textMixin({
            fontSize: '2rem',
            fontWeight: 600,
        })};
        line-height: 28px;
        text-align: center;
        color: ${colors.white};
        height: 36px;
    }

    .ant-picker .ant-picker-input,
    .ant-picker .ant-picker-range,
    .ant-picker .ant-picker-input-active .ant-picker-input-placeholder {
        display: flex;
        flex-direction: row-reverse;
        ${textMixin({
            fontSize: '0.875rem',
            fontWeight: 400,
        })};
        line-height: 28px;
        color: ${colors.white};
    }

    .ant-picker .ant-picker-input .ant-picker-input-active {
        color: ${colors.white} !important;
    }

    .ant-picker .ant-picker-input .ant-picker-input-placeholder {
        color: ${colors.white}!important;
    }

    .ant-picker .ant-picker-input span.ant-picker-suffix,
    .ant-picker.ant-picker-range span.ant-picker-suffix {
        order: -1;
        margin-left: 0;
        margin-right: 10px;
        color: ${colors.white};
    }

    .ant-picker.ant-picker-range.ant-picker-range-separator {
        color: ${colors.white}!important;
    }

    .ant-picker-range-separator > span {
        color: ${colors.white}!important;
    }

    .ant-picker-clear {
        color: ${colors.white}!important;
    }

    .ant-picker .ant-picker-clear {
        position: absolute;
        right: 9px;
    }
`;

export const TableWrapper = styled.div`
    margin-top: 10px;
    width: 100%;

    .ant-table-thead {
        height: 50px;
        line-height: 50px;
        margin-bottom: 5px !important;
        background: rgba(148, 129, 205, 0.25);
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
        border-radius: 5px 5px 0 0;
    }
    .ant-table-thead > tr > th::before {
        content: none !important;
    }
    .ant-table-cell {
        border-right: none !important;
        border-left: none !important;
    }

    .ant-table-row {
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
    }

    .ant-table-row .ant-table-cell {
        height: 46px !important;
        ${textMixin({
            fontSize: '0.875rem',
            fontWeight: 400,
        })}
        align-items: center;
        color: ${colors.grey};

        & svg {
            margin-top: 9px;
            cursor: pointer;
        }
    }
`;
export const Overlay = styled.div<{
    display: string;
}>`
    display: ${({ display }) => display};
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(1px);
`;
